const initialState = {}

export default function client (state = initialState, action) {
  switch (action.type) {
    case 'SET_CLIENT':
      return {
        ...action.value
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/client.js